import { render, staticRenderFns } from "./PortineriaTabelloneEsportaView.vue?vue&type=template&id=0fc6e4c6&"
import script from "./PortineriaTabelloneEsportaView.vue?vue&type=script&lang=ts&"
export * from "./PortineriaTabelloneEsportaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports